module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.library.js
// module id = 309
// module chunks = 0